export default {"src":"/leva/_next/static/media/backer-badge.cd37e9f4.svg","height":64,"width":128,"blurWidth":0,"blurHeight":0};